import SidebarComponent from 'components/sidebar/Sidebar';
import { METADATA_SUB_PATHS, SHORTS_SUB_PATHS } from 'constants/index';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { accountStore } from 'store/accountStore';
import { default as CustomBreadcrumb } from '../breadcrumb/Breadcrumb';
import './BasePage.css';
import PageHeader from './PageHeader';

// URL 첫 세그먼트와 사이드바 메뉴 key가 다른 경우의 매핑 (constants/menu.ts 참고)
const PATH_TO_MENU_KEY: Record<string, string> = {
  '': 'import-upload',
  main: 'import-upload',
  playlists: 'playlist',
  library: 'content',
  video: 'content',
  episode: 'content',
  'clip-trailer': 'content',
  'content-provider': 'company',
  assets213: 'assets',
  'assets-source': 'assets',
  shorts: 'shorts-list',
};

// 상세/수정 페이지에서도 소속 메뉴가 하이라이트되도록 pathname을 메뉴 key로 변환
const getMenuKey = (pathname: string): string => {
  const [, first = '', second] = pathname.split('/');
  if (first === 'vendor' && second) return `vendor-${second}`;
  if (pathname.startsWith('/assets/add-vn')) return 'vietnam-upload-new';
  return PATH_TO_MENU_KEY[first] ?? first;
};

export interface BaseProps {
  children: React.ReactNode;
}

const BasePage: React.FC<BaseProps> = observer(({ children }) => {
  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1];
  const currentPath = getMenuKey(location.pathname);
  const defaultOpenKeys = [
    ...(METADATA_SUB_PATHS.includes(pathSegment) ? ['metadata'] : []),
    ...(SHORTS_SUB_PATHS.includes(pathSegment) ? ['shorts'] : []),
  ];
  const breadcrumbs = CustomBreadcrumb();
  // 벤더 페이지: raw ID 누적 대신 최상위 2단계까지만 label 매핑해서 노출.
  const isVendorRoute = location.pathname.startsWith('/vendor');
  const vendorLabelMap: Record<string, string> = {
    vendor: 'Vendor',
    download: 'Download',
    subtitle: 'Subtitle',
  };
  const breadcrumbItems = isVendorRoute
    ? location.pathname
        .split('/')
        .filter(Boolean)
        .slice(0, 2)
        .map((seg, index) => ({
          title: vendorLabelMap[seg] ?? seg,
          key: index,
        }))
    : breadcrumbs.map((breadcrumb, index) => ({
        title: breadcrumb.title,
        key: index,
        href: breadcrumb.url,
      }));

  useEffect(() => {
    if (!accountStore.isInit()) {
      accountStore.init().then();
    }
  }, []);

  return (
    <SidebarComponent currentPath={currentPath} defaultOpenKeys={defaultOpenKeys}>
      <PageHeader
        userName={accountStore.getAccount()?.username || ''}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="base-page-component">{children}</div>
    </SidebarComponent>
  );
});

export default React.memo(BasePage);
